import { render, staticRenderFns } from "./billiards_params_set.vue?vue&type=template&id=01803602&scoped=true"
import script from "./billiards_params_set.vue?vue&type=script&lang=js"
export * from "./billiards_params_set.vue?vue&type=script&lang=js"
import style0 from "./billiards_params_set.vue?vue&type=style&index=0&id=01803602&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01803602",
  null
  
)

export default component.exports